<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="tp">
<h1 class="bk">Pure Act</h1>
<h1 class="bk1">The Uncommon Life of Robert Lax</h1>
<p class="bkau">Michael N. McGregor</p>
<p class="bkpub"><a class="page"></a>Fordham University Press</p>
<p class="bkpub1">New York 2015</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// McGregor0002.vue?958bd102